<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    class="verify-box"
    style="width: 500px"
  >
    <el-dialog
      title="修改付款信息"
      :visible="true"
      width="40%"
      :before-close="onCloseDialog"
    >
      <el-form>
        <el-form-item label="收款人银行账号">
          <el-input
            v-model="form.pay_account"
            placeholder="请输入收款人银行账号"
            style="width: 80%; float: right"
          ></el-input>
        </el-form-item>
        <el-form-item label="收款人姓名">
          <el-input
            v-model="form.pay_contact"
            placeholder="请输入收款人姓名"
            style="width: 80%; float: right"
          ></el-input>
        </el-form-item>
        <el-form-item label="收款人银行">
          <el-select
            v-model="form.pay_bank"
            filterable
            placeholder="收款银行"
            style="width: 80%; float: right"
          >
            <el-option
              v-for="item in banks"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <!--<el-input v-model="submitData.pay_bank" placeholder="请输入收款人银行" style="width: 80%;float: right"></el-input>-->
        </el-form-item>
        <el-form-item label="收款人支行">
          <el-select
            v-model="form.cnap"
            filterable
            remote
            :remote-method="setCnap"
            placeholder="所属支行(至少输入四位才可以筛选)"
            style="width: 80%; float: right"
          >
            <el-option value="">请选择</el-option>
            <el-option
              v-for="item in cnaps"
              :key="item.cnap"
              :label="item.cnap_name"
              :value="item.cnap"
            >
            </el-option>
          </el-select>
          <!--<el-input v-model="submitData.pay_bank" placeholder="收款人支行" style="width: 80%;float: right"></el-input>-->
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="form.pay_remark"
            placeholder="请输入备注"
            style="width: 80%; float: right"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseDialog">取 消</el-button>
        <el-button type="primary" @click="update_payee()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    payee: {
      type: Object,
      default: () => ({}),
    },
    old: {
      type: Object,
      default: () => ({}),
    },
    url: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {},
      cnaps: [],
      banks: [],
      loading: false,
      show: true,
      count: "",
      fullscreenLoading: false,
    };
  },
  mounted() {
    this.filterData();
  },
  methods: {
    // setA(v){
    //     console.log(typeof v);
    // },
    filterData() {
      this.$http.get("/erp/common/getBank").then((res) => {
        if (res.data.code != 200) {
          this.$message.error(res.data.msg);
          return;
        }
        this.banks = res.data.data;

        this.payee.pay_remark = "";
        this.$http
          .post("/erp/common/getCnap", { bank: this.payee.pay_bank })
          .then((res) => {
            this.cnaps = res.data.data;
            this.form = {
              ...this.payee,
            };
          });
      });
    },
    update_payee() {
      // 提交修改日志
      // 新增一个变量,不这样做,会有问题
      // this.form.cnap=this.form.c;
      this.$http
        .post(this.url, {
          id: this.id,
          new_payee: this.form,
          old: this.old,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.onCloseDialog();
          }
        });
    },
    setCnap(v) {
      if (v.length >= 4) {
        this.$http
          .post("/erp/common/getCnap", {
            bank: this.form.pay_bank,
            cnap_name: v,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.cnaps = res.data.data;
            }
          });
      }
    },
    onCloseDialog() {
      this.$emit("onCloseDialog", false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/wcgorder/components/UpdatePayee.vue